import React from "react"
import Layout from "../components/Layout"
import { graphql } from "gatsby"
import Projects from "../components/LoadMore"
import SEO from "../components/SEO"

const ProjectsPage = ({
  data: {
    allStrapiProjects: { nodes: projects },
  },
}) => {
  return (
    <Layout>
      <SEO title="Project" description="real estate new launch" />
      <section className="project-page">
        <Projects projects={projects} title="all projects" />
        
      </section>
    </Layout>
  )
}

export const query = graphql`
  {
    allStrapiProjects {
      nodes {
        id
        slug
        title
        overview
        url
        github
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        stack {
          id
          title
        }
        image2 {
          childImageSharp {
            fluid {
              src
            }
          }
        }
        image3 {
          childImageSharp {
            fluid {
              src
            }
          }
        }
        overview
        propertyDetails {
          BroadRegion
          Category
          Country
          District
          Location
          ProjectName
          Region
          Road
        }
        locationMap {
          id
          url
        }
        unitMix {
          AreaSqft
          BedroomType
          Units
        }
        floorPlan {
          id
          publicURL
        }
      }
    }
  }
`

export default ProjectsPage
